import React, { Component } from 'react'
import Layout from './../../wrapper'
import { connect } from 'react-redux'
import withTranslationWrapper from '../../HOC/HocTranslate'
import { notifyError } from '../../Utils/CustomNotifcations'
import { DeviceList } from '../../Components/Devices/deviceModalForSuperAdmin'
import { logInUserInfo } from '../../Actions/Users'

import { checkPrivileges } from '../../Helpers'
import withRoutes from '../../HOC/HocRoutes'
import instance from '../../axios'
import { apiFetch } from '../../Utils/apiFetch'

class Devices extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isVisable: true,
      sessionCallTrack: true,
      unitsApiCall: true
    }
  }
  componentWillMount () {
        // this.props.dispatch(Notifications.removeAll())
  }
  controleSession = () => {
    if (localStorage.getItem('userInfo')) {
      apiFetch('/api/session', {
        method: 'DELETE'
      }).then(res => {
        let response = res.data
        if (response.ok) {
          this.props.navigate('/logout')
        }else{
          throw response
        }
      }).catch(e => {})
    }
  }
  render () {
    if (checkPrivileges('device')) {
      if (this.props.logInUser) {
        // if (this.props.logInUser.userType === 6) {
        //   this.props.navigate('/*')
        // } else {
          return (
            <Layout {...this.props}>
              <DeviceList {...this.props} />
            </Layout>
          )
        // }
      } else {
        if (this.state.sessionCallTrack) {
              this.setState(
                {
                  sessionCallTrack: false
                },
                () => {
                  apiFetch('/api/session?app=2bd5bd10345cd1555b14c221ec6e8647c46ee21e8ee45312', {
                    headers: { Accept: 'application/json; odata=verbose' }
                  }).then(response => {
                    if (response.ok) {
                      response.json().then(res => {
                        if(res.status ==='success'){ 
                          let userInfo = res.data
                          this.props.setActiveLanguage(
                            userInfo?.attributes?.lang || 'en'
                          )
      
                          //API privilige call
                          apiFetch(`/api/privileges?roleId=${userInfo.roleId}`, {
                            method: 'Get'
                          })
                            .then(response => {
                              if (response.ok) {
                                response.json().then(res2 => {
                                  if(res.status ==='success'){ 
                                    let privileges = res2.data
                                    let privilegeKeys = []
                                    privileges.map(item => {
                                      privilegeKeys.push(item.key)
                                    })
                                    localStorage.setItem(
                                      'privileges',
                                      JSON.stringify({ ...privilegeKeys })
                                    )
                                    if (privileges.length) {
                                      localStorage.setItem('userToken', '')
                                      this.props.navigate('/units')
                                    } else {
                                      this.setState({
                                        loading: false,
                                        loginErrorMessage: 'lackOfPrivileges'
                                      })
                                    }
                                  }
                                  else if(res?.statusCode === '440'){
                                    window.location.replace('/login')
                                  }
                                  else if(res.statusCode){
                                    var err = res?.message.split(':')
                                    err[1] =err[1].replace(')', "")
                                    this.props.dispatch(
                                      notifyError(err[1])
                                    )
                                  }
                                })
                              } else {
                                throw response
                              }
                            })
                            .catch(e => {
                                console.log('e =',e)
                              // this.props.dispatch(notifyError({
                              //   message: 'somethingWentWrong',
                              //   autoDismiss: 5
                              // }))
                            })
      
                          //Privilige call ends
      
                          this.props.dispatch(logInUserInfo(userInfo))
    
                        }
                        else if(res?.statusCode === '440'){
                          window.location.replace('/login')
                        }
                        else if(res.statusCode){
                          var err = res?.message.split(':')
                          err[1] =err[1].replace(')', "")
                          this.props.dispatch(
                            notifyError(err[1])
                          )
                          this.props.navigate('/logout')
                        }
                      })
                    } else {
                      this.props.navigate('/logout')
                        throw response
                      }
                    }).catch(e => {
                      this.props.dispatch(notifyError('somethingWentWrong'))
                    })
                }
              )
            }
        return null
      }
    } else if (
      !checkPrivileges('account') &&
      !checkPrivileges('user') &&
      !checkPrivileges('group')
    ) {
      this.controleSession()
      return null
    } else {
      return defaultPages.map(page => {
        if (checkPrivileges(page)) {
          this.props.navigate(`/${page}s`)
        }
        return null
      })
    }
  }
}
const mapStateToProps = state => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  users: state.users,
  roles: state.roles,
  devices: state.devices
})

export default connect(mapStateToProps)(withRoutes(withTranslationWrapper(Devices)))

const defaultPages = ['accounts', 'users', 'group']
